import { render, staticRenderFns } from "./InterpretationInterpretations.vue?vue&type=template&id=fde4b2c0&v-if=flagComponents%20%3D%3D%20true&"
import script from "./InterpretationInterpretations.vue?vue&type=script&lang=js&"
export * from "./InterpretationInterpretations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports